module.exports = __webpack_public_path__ + "static/linkedin-f4d171340258d5e994157f679a73dd5f.webm";